import request from "@/utils/request.js";

// 俱乐部-详情(跨租户)
export const getClubIgnore = (id) => {
    return request.get(`/club/ignoreTenant/${id}`)
}

// 俱乐部信息-新增(跨租户)
export const addClubIgnore = (formData) => {
    return request.post(`/club/ignoreTenant`, formData)
}

// 俱乐部会员邀请码(跨租户)
export const createClubQrCodeIgnore = (id) => {
    return request.put(`/club/ignoreTenant/createQrCode/${id}`);
};

// 俱乐部信息-修改(跨租户)
export const updateClubIgnore = (updateData) => {
    return request.put(`/club/ignoreTenant/clubInfo/${updateData.storeId}`, updateData);
};

// 俱乐部主理人-修改(跨租户)
export const updateClubPersonnelInfoIgnore = (storeId, updateData) => {
    return request.put(`/club/ignoreTenant/personnelInfo/${storeId}`, updateData);
};
